import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import PreSalePage from '../PreSalePage/PreSalePage';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/presale" element={<PreSalePage />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
